import { Api } from "../..";
import {
  API_DELETE_COMMUNICATION_TEMPLATE,
  API_GET_ALL_COMMUNICATION_TEMPLATES,
  API_GET_COMMUNICATION_TEMPLATE_VERSION_HISTORY,
  API_POST_CREATE_COMMUNICATION_TEMPLATE,
  API_POST_REVERT_COMMUNICATION_TEMPLATE_VERSION,
  API_PUT_COMMUNICATION_TEMPLATE,
} from "../../Apis/ApiEndPoints";
import {
  ICreateCommunicationTemplatesPayload,
  ICreateCommunicationTemplatesResponse,
  IDeleteCommunicationTemplateResponse,
  IGetAllCommunicationTemplatesResponse,
  IGetCommunicationTemplateVersionsResponse,
  IRevertTemplateVersionPayload,
  IRevertTemplateVersionResponse,
  IUpdateCommunicationTemplatesPayload,
} from "../../models/admin/communicationTemplates/communicatinTemplates";

import { CustomAction } from "./../../store/customAction";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllCommunicationTemplates = createAsyncThunk(
  "getAll/communicationTemplates",
  async (_, { dispatch }) => {
    const response: IGetAllCommunicationTemplatesResponse = await CustomAction(
      Api.get(API_GET_ALL_COMMUNICATION_TEMPLATES),
      dispatch,
      "getAll/communicationTemplates"
    );
    return response;
  }
);

export const createCommunicationTemplates = createAsyncThunk(
  "create/communicationTemplates",
  async (
    requestPayload: ICreateCommunicationTemplatesPayload,
    { dispatch }
  ) => {
    const response: ICreateCommunicationTemplatesResponse = await CustomAction(
      Api.post(API_POST_CREATE_COMMUNICATION_TEMPLATE, requestPayload),

      dispatch,
      "create/communicationTemplates"
    );
    return response;
  }
);

export const updateCommunicationTemplates = createAsyncThunk(
  "update/communicationTemplates",
  async (
    requestPayload: IUpdateCommunicationTemplatesPayload,
    { dispatch }
  ) => {
    const { id, ...payloadWithoutId } = requestPayload;
    const response: ICreateCommunicationTemplatesResponse = await CustomAction(
      Api.put(
        `${API_PUT_COMMUNICATION_TEMPLATE}/${requestPayload?.id}`,
        payloadWithoutId
      ),
      dispatch,
      "update/communicationTemplates"
    );
    return response;
  }
);

export const deleteCommunicationTemplates = createAsyncThunk(
  "delete/communicationTemplates",
  async (temlpateId: string, { dispatch }) => {
    const response: IDeleteCommunicationTemplateResponse = await CustomAction(
      Api.delete(`${API_DELETE_COMMUNICATION_TEMPLATE}/${temlpateId}`),
      dispatch,
      "delete/communicationTemplates"
    );
    return response;
  }
);

export const getCommunicationTemplateversions = createAsyncThunk(
  "getCommunicationTemplate/versions",
  async (templateId: string, { dispatch }) => {
    const response: IGetCommunicationTemplateVersionsResponse =
      await CustomAction(
        Api.get(
          `${API_GET_COMMUNICATION_TEMPLATE_VERSION_HISTORY}/${templateId}/versions`
        ),
        dispatch,
        "getCommunicationTemplate/versions"
      );
    return response;
  }
);

export const revertTemplateVersion = createAsyncThunk(
  "admin/revertTemplateVersion",
  async (requestPayload: IRevertTemplateVersionPayload, { dispatch }) => {
    const response: IRevertTemplateVersionResponse = await CustomAction(
      Api.post(
        `${API_POST_REVERT_COMMUNICATION_TEMPLATE_VERSION}/${requestPayload.templateId}/revert/${requestPayload.version}`,
        requestPayload
      ),

      dispatch,
      "admin/revertTemplateVersion"
    );
    return response;
  }
);
